import { AdminManagement } from "@pages/Admin/AdminPage";
import { AgencyManagement } from "@pages/Agency/AgencyManagementPage";
import { BrandManagement } from "@pages/Brand/BrandPage";
import { BucketInfluencerPage } from "@pages/bucket/BucketInfluencerPage";
import { BucketPage } from "@pages/bucket/BucketPage";
import { DiscoveryPage } from "@pages/discovery/DiscoveryPage";
import { InfluencerManagement } from "@pages/Influencer/InfluencerManagementPage";
import { DefaultLayout } from "@pages/layout/DefaultLayout";
import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import { ROUTES } from "./constants";

// import BriefInfluencersPage from "@pages/Brief/BriefInfluencersPage";
import { CampaignReachoutManagement } from "@pages/Campaign Reach Out/InfluencerCampaignReachOutPage";
import { ReportsPage } from "@pages/Reports";
import { ReportDetailPage } from "@pages/Reports/ReportDetailPage";
import { ReportMediaPage } from "@pages/Reports/ReportMedia";

import { CampaignAiSettingsPanel } from "@features/CampaignAiSettings/ui/CampaignAiSettingsPanel";
import PricingProject from "@features/PricingProject/ui";
import { AdvancedYoutubeSearchPage } from "@pages/AdvancedYoutubeSearch";
import { AgencyInfluencers } from "@pages/Agency/AgencyInfluencers";
import { AIWorkspacePage } from "@pages/AIWorkspace";
import { AIWorkspaceDetailPage } from "@pages/AIWorkspaceDetail";
import { BrandBillingManagement } from "@pages/BrandBilling/BrandBillingPage";
import { BriefFinance } from "@pages/Brief/v2/BriefFinance";
import { BriefPricingTracking } from "@pages/Brief/v2/BriefPricingTracking/BriefPricingTracking";
import BriefCampaignsAll from "@pages/BriefCampaignsV2/BriefCampaignsAll";
import BriefDiscoveryTracking from "@pages/BriefDiscoveryTracking/BriefDiscoveryTracking";
import { CampaignDetail } from "@pages/CampaignDetail";
import CampaignOverviewPage from "@pages/CampaignOverview";
import CampaignsPage from "@pages/CampaignsV2";
import { ClosureDetailPage } from "@pages/ClosureDetail";
import { ClosuresManagementPage } from "@pages/Closures";
import DeliverableConfigurator from "@pages/DeliverableConfigurator/DeliverableConfigurator";
import { FinanceApproval } from "@pages/FinanceApproval";
import { FinancePage } from "@pages/FinancePage";
import { GstInvoices } from "@pages/GstInvoices";
import { BriefLayout } from "@pages/layout/BriefLayout";
import { AdminInfluencerRequests } from "@pages/manageRequests/AdminInfluencerRequests";
import { MyPricing } from "@pages/MyPricing";
import Onboarding from "@pages/Onboarding/Onboarding";
import OrganisationManagement from "@pages/Organisation/OrganisationPage";
import { Payouts } from "@pages/Payouts/Payouts";
import PersonalSettingsPage from "@pages/PersonalSettings";
import { PricingTracker } from "@pages/PricingTracker/PricingTracker";
import { GlobalDiscoverPage } from "../GlobalDiscoverPage";
// import { Test } from "@pages/Test";

const routes: RouteObject[] = [
  {
    path: ROUTES.LOGIN,
    element: <Onboarding />,
  },

  {
    element: <DefaultLayout />,
    children: [
      {
        path: ROUTES.HOME,
        element: <Navigate to={ROUTES.BRIEF} />,
      },
      {
        path: ROUTES.Admin,
        element: (
          <div>
            <AdminManagement />
          </div>
        ),
      },
      // {
      //   path: ROUTES.INFLUENCER_CONTACT_VERIFICATION,
      //   element: <ContactsVerification />,
      // },

      {
        path: ROUTES.BRAND,
        element: (
          <div>
            <BrandManagement />
          </div>
        ),
      },
      {
        path: ROUTES.ORGANISATION,
        element: (
          <div>
            <OrganisationManagement />
          </div>
        ),
      },
      {
        path: ROUTES.BRIEF,
        element: (
          <div>
            {/* <BreifCampaignWrapper /> */}
            <CampaignsPage />
          </div>
        ),
      },
      {
        path: ROUTES.DELIVERABLE_CONFIGURATOR,
        element: <DeliverableConfigurator />,
      },
      {
        path: ROUTES.PERMISSIONS,
        // element: (
        //   <div>
        //     <PermissionGroups />
        //   </div>
        // ),
      },
      {
        path: ROUTES.REPORTS,
        element: (
          <div>
            <ReportsPage />
          </div>
        ),
      },

      {
        path: ROUTES.PRICING_TRACKING,
        element: <BriefPricingTracking />,
      },
      {
        path: ROUTES.DISCOVERY_TRACKING,
        element: <BriefDiscoveryTracking />,
      },
      {
        path: ROUTES.REPORT_DETAIL,
        element: (
          <div>
            <ReportDetailPage />
          </div>
        ),
      },
      {
        path: ROUTES.REPORT_MEDIA,
        element: (
          <div>
            <ReportMediaPage />
          </div>
        ),
      },
      {
        path: ROUTES.Agency,
        element: (
          <div>
            <AgencyManagement />
          </div>
        ),
      },
      {
        path: ROUTES.AGENCY_INFLUENCER,
        element: (
          <div>
            <AgencyInfluencers />
          </div>
        ),
      },
      {
        path: ROUTES.INFLUENCER,
        element: (
          <div>
            <InfluencerManagement />
          </div>
        ),
      },
      {
        path: ROUTES.SOCIALMEDIA,
        element: (
          <div>
            <DiscoveryPage />
          </div>
        ),
      },
      {
        path: ROUTES.BUCKET,
        element: (
          <div>
            <BucketPage />
          </div>
        ),
      },
      {
        path: ROUTES.REQUESTS,
        element: (
          <div>
            <AdminInfluencerRequests />
          </div>
        ),
      },
      {
        path: ROUTES.BUCKETINFLUENCERS,
        element: (
          <div>
            <BucketInfluencerPage />
          </div>
        ),
      },
      {
        path: ROUTES.GLOBAL_DISCOVERY,
        element: (
          <div>
            <GlobalDiscoverPage />
          </div>
        ),
      },
      {
        path: ROUTES.ADVANCED_YOUTUBE_SEARCH,
        element: <AdvancedYoutubeSearchPage />,
      },
      {
        path: ROUTES.AI_WORKSPACE,
        element: <AIWorkspacePage />,
      },
      {
        path: ROUTES.AI_WORKSPACE_DETAIL,
        element: <AIWorkspaceDetailPage />,
      },

      {
        path: ROUTES.BRIEF_INFLUENCERS,
        element: <div>Depreciated</div>,
      },

      {
        path: ROUTES.INFLUENCER_CAMPAIGN_REACHOUT,
        element: (
          <div>
            <CampaignReachoutManagement />
          </div>
        ),
      },

      {
        path: ROUTES.BRAND_BILLING,
        element: (
          <div>
            <BrandBillingManagement />
          </div>
        ),
      },
      {
        path: ROUTES.FINANCE_APPROVAL_LOT,
        element: <FinanceApproval />,
      },
      {
        path: ROUTES.GST_INVOICES,
        element: <GstInvoices />,
      },
      {
        path: ROUTES.PAYOUTS,
        element: <Payouts />,
      },
      {
        path: ROUTES.PRICING_TRACKER,
        element: <PricingTracker />,
      },
      {
        path: ROUTES.ACCOUNTING,
        element: <FinancePage />,
      },
      {
        path: ROUTES.MY_PRICING,
        element: <MyPricing />,
      },
      {
        path: ROUTES.CLOSURES,
        element: <ClosuresManagementPage />,
      },
      {
        path: ROUTES.CLOSURE_DETAIL,
        element: <ClosureDetailPage />,
      },
      {
        path: ROUTES.MY_PRICING_PROJECT,
        element: <PricingProject />,
      },
      {
        element: <BriefLayout />,
        children: [
          // {
          //   path: ROUTES.BRIEF_V2_CONFIG,
          //   element: <BriefConfigurationPage />,
          // },
          {
            path: ROUTES.BRIEF_V2,
            element: <CampaignDetail />, //<BriefInfluencersPageV2 />,
          },
          {
            path: ROUTES.BRIEF_V2_REPORT,
            element: <ReportDetailPage />,
          },
          {
            path: ROUTES.BRIEF_V2_BILL,
            element: <BriefFinance />,
          },
          // {
          //   path: ROUTES.BRIEF_V2_SETTINGS,
          //   element: <BriefSettingsPage />,
          // },
          {
            path: ROUTES.BRIEF_V2_CAMPAIGNS,
            element: <BriefCampaignsAll />, //<BriefCampaignsPage />,
          },
          {
            path: ROUTES.BRIEF_V2_OVERVIEW,
            element: <CampaignOverviewPage />,
          },
          {
            path: ROUTES.BRIEF_V2_AI_OVERVIEW,
            element: <CampaignAiSettingsPanel />,
          },
        ],
      },
      {
        path: ROUTES.PERSONAL_SETTINGS,
        element: <PersonalSettingsPage />,
      },
    ],
  },
  // {
  //   path: "test",
  //   element: (
  //     <div>
  //       <Test />
  //     </div>
  //   ),
  // },
  // {
  //   path: ROUTES.BRIEF_V2_SCRIPT,
  //   element: <BriefScriptPage />,
  // },
  // {
  //   path: ROUTES.DRAFTING,
  //   element: (
  //     <ProtectedLayoutWrapper>
  //       <DraftPage />
  //     </ProtectedLayoutWrapper>
  //   ),
  // },
  {
    path: "*",
    element: <Navigate to={ROUTES.BRIEF} />,
  },
];

const router = createBrowserRouter(routes);

export default router;
